import React, { useState, useCallback, useEffect } from "react";
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import GuidesPage from "./pages/GuidesPage";
import RankingPage from "./pages/RankingPage";
import DetailPage from "./pages/DetailPage";
import QuizPage from "./pages/QuizPage";

function urlToPage() {
  const params = new URLSearchParams(window.location.search);
  const t = params.get("page") || "home";
  const p = { t };
  const code = params.get("code");
  const from = params.get("from");
  const filter = params.get("filter");
  const sort = params.get("sort");
  const dir = params.get("dir");
  const category = params.get("category");
  if (code) p.code = code;
  if (from) p.from = from;
  if (filter) p.filter = filter;
  if (sort) p.sort = sort;
  if (dir) p.dir = dir;
  if (category) p.category = category;
  return p;
}

function pageToUrl(p) {
  const params = new URLSearchParams();
  if (p.t !== "home") params.set("page", p.t);
  if (p.code) params.set("code", p.code);
  if (p.from) params.set("from", p.from);
  if (p.filter) params.set("filter", p.filter);
  if (p.sort) params.set("sort", p.sort);
  if (p.dir) params.set("dir", p.dir);
  if (p.category) params.set("category", p.category);
  const qs = params.toString();
  return qs ? `?${qs}` : window.location.pathname;
}

export default function App() {
  const [page, setPage] = useState(urlToPage);

  const go = useCallback((p) => {
    setPage(p);
    window.history.pushState(p, "", pageToUrl(p));
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const onPop = () => setPage(urlToPage());
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return (
    <div className="app">
      <Nav page={page} go={go} />
      {page.t === "home" && <HomePage go={go} />}
      {page.t === "guides" && <GuidesPage go={go} initialCont={page.filter} initialCategory={page.category} />}
      {page.t === "ranking" && <RankingPage go={go} page={page} />}
      {page.t === "detail" && <DetailPage page={page} go={go} />}
      {page.t === "quiz" && <QuizPage go={go} />}
      {page.t !== "quiz" && <Footer />}
    </div>
  );
}
